import React from 'react';

import { getGoogleClientId, getSpaUrl } from '@config/getEnviroment';
import { BtnGoogle } from '@components/Auth/SignIn/styled';
import { ReactComponent as BtnGoogleSvg } from '@assets/images/google.svg';
import { useGoogleOAuthState } from '@hooks/useGoogleOAuthState';

const GoogleSsoBtn = () => {
  const { createState } = useGoogleOAuthState();
  const clientId = getGoogleClientId();
  const callbackPath = '/oauth/calback';
  const redirectUri = `${getSpaUrl()}${callbackPath}`;
  const state = createState();

  const url =
    `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&state=${encodeURI(state)}` +
    `&redirect_uri=${redirectUri}&response_type=code&scope=openid email profile`;

  return (
    <>
      <BtnGoogle href={url}>
        <BtnGoogleSvg />
        Inicia sesión con Google
      </BtnGoogle>
    </>
  );
};

export default GoogleSsoBtn;
